import { VxlHairlineComponent } from '@varo/graphql-schema-types';
import HairLineDivider from 'shared/components/vxl/divider/HairlineDivider/HairLineDivider';

export default function vxlHairline(element: VxlHairlineComponent) {
  return {
    id: element.id,
    render: () => HairLineDivider(),
  };
}
